import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

export default function BookDetails() {
  const { id } = useParams(); // id can be id OR author OR email
  const navigate = useNavigate();
  const [book, setBook] = useState(null);

  useEffect(() => {
    // 1️⃣ Try fetch by ID first
    fetch(`https://book-inventory-backend-ze7h.onrender.com/books/${id}`)
      .then((res) => {
        if (!res.ok) throw new Error("Not found by id");
        return res.json();
      })
      .then(setBook)
      .catch(() => {
        // 2️⃣ If not found, search by author or email
        fetch(
          `https://book-inventory-backend-ze7h.onrender.com/books?search=${id}`
        )
          .then((res) => res.json())
          .then((data) => {
            if (data.length > 0) {
              setBook(data[0]); // pick first matching book
            } else {
              setBook(null);
            }
          });
      });
  }, [id]);

  if (!book) return <p>Loading...</p>;

  return (
    <div style={{ padding: 30 }}>
      <h2>{book.bookName}</h2>
      <p><b>Author:</b> {book.author}</p>
      <p><b>Year:</b> {book.year}</p>
      <p><b>Email:</b> {book.email}</p>
      <p><b>Genre:</b> {book.genre}</p>

      <button onClick={() => navigate(-1)}>⬅ Back</button>
    </div>
  );
}
